import { render, staticRenderFns } from "./assignedInstitutionsListItem.vue?vue&type=template&id=674733b4"
import script from "./assignedInstitutionsListItem.vue?vue&type=script&lang=ts"
export * from "./assignedInstitutionsListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports